import React from 'react';
import {
  Body,
  designSystemToken,
  Headline,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './EmptyBrandState.module.scss';

const LOGO_SRC = '/assets/svg/logo-p-green.svg';

export interface EmptyBrandStateProps {
  organizationOwnerEmail?: string;
  testID?: string;
}

function EmptyBrandState({
  organizationOwnerEmail,
  testID = 'empty-brand-state',
}: EmptyBrandStateProps) {
  return (
    <div className={styles.container} data-testid={testID}>
      <div className={styles.content}>
        <img
          src={LOGO_SRC}
          alt="Popular Pays"
          className={styles.logo}
          data-testid={`${testID}-logo`}
        />
        <Headline size="lg" color={designSystemToken('semantic.fg.primary')}>
          {translate('Welcome to Popular Pays!')}
        </Headline>
        <Body
          size="lg"
          color={designSystemToken('semantic.fg.secondary')}
          className={styles.description}
        >
          {translate(
            'No brands have been assigned to your account yet. Contact your organization administrator to get access.'
          )}
        </Body>
        {organizationOwnerEmail && (
          <Body
            size="md"
            color={designSystemToken('semantic.fg.tertiary')}
            className={styles.ownerEmail}
            data-testid={`${testID}-owner-email`}
          >
            {translate('Organization owner:', {
              email: organizationOwnerEmail,
            })}
          </Body>
        )}
      </div>
    </div>
  );
}

export default EmptyBrandState;
